// https://stackoverflow.com/a/4819886/6193734
const isTouchDevice = (): boolean =>
  "ontouchstart" in window || navigator.maxTouchPoints > 0

export default isTouchDevice
